<template>
  <el-table height="100%" :data="results" highlight-current-row border stripe>
    <el-table-column type="expand">
      <template slot-scope="scope">
        <el-descriptions :column="1" size="mini" border style="margin: 0 10px">
          <el-descriptions-item v-if="scope.row.title">
            <template slot="label"> 标题 </template>
            {{ scope.row.title }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 描述 </template>
            {{ scope.row.description }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 订单内容 </template>
            {{ scope.row.content }}
          </el-descriptions-item>
          <el-descriptions-item v-if="scope.row.extraData">
            <template slot="label"> 扩展数据 </template>
            {{ scope.row.extraData }}
          </el-descriptions-item>
        </el-descriptions>
      </template>
    </el-table-column>
    <el-table-column prop="id" label="ID" width="100"></el-table-column>
    <el-table-column prop="payMethod" label="支付方式" width="100"></el-table-column>
    <el-table-column prop="bizType" label="订单类型">
      <template slot-scope="scope">
        {{ orderType[scope.row.bizType] || scope.row.bizType }}
      </template>
    </el-table-column>
    <el-table-column prop="bizId" label="订单ID"></el-table-column>
    <el-table-column prop="userId" label="用户">
      <template slot-scope="scope">
        <user-info :user="scope.row.user" />
      </template>
    </el-table-column>
    <el-table-column prop="amount" label="金额"></el-table-column>
    <el-table-column prop="payStatus" label="支付状态">
      <template slot-scope="scope">
        <el-tag :type="scope.row.payStatus === 0 ? 'danger' : 'primary'">{{
          payStatus[scope.row.payStatus] || scope.row.payStatus
        }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column prop="paidTime" label="支付时间"></el-table-column>
    <el-table-column prop="createTime" label="创建时间"></el-table-column>
    <el-table-column prop="updateTime" label="修改时间"></el-table-column>
    <el-table-column label="操作" width="150">
      <template slot-scope="scope">
        <el-button
          type="primary"
          size="mini"
          :disabled="scope.row.payStatus !== 0"
          @click="setPaid(scope.$index, scope.row)"
          >设为已支付</el-button
        >
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import UserInfo from "@/components/UserInfo";
export default {
  components: { UserInfo },
  props: {
    results: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      orderType: {
        BUYER_ORDER: "买家订单",
        BUYER_BALANCE_ORDER: "买家求购支付尾款",
        SELLER_ORDER: "卖家订单",
      },
      payStatus: {
        0: "未支付",
        1: "已支付",
      },
    };
  },
  methods: {
    async setPaid(index, row) {
      try {
        await this.axios.get("mall:/api/admin/payment-order/setPaid?id=" + row.id);
        row.payStatus = 1;
        this.$notify.success("Success");
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
  },
};
</script>

<style></style>
